import React, { useState } from "react";
import { Layout, Menu , Button} from '../AntComponent';
import '../../assets/styles/LandingPage.scss';
import GarudaLogo from '../../assets/images/newlogo.svg';
import fb from '../../assets/icons/facebook.png'
import indeed from '../../assets/icons/indeedIcon.png'
import insta from '../../assets/icons/instagram.png'
import twit from '../../assets/icons/twitter.png'
import KosoftLogo from '../../assets/icons/kosoftlogo.svg'
import Login from "../Login";
const { Header, Content, Footer } = Layout;

export default function LandingLayoutFile({children}) {
    const [current, setCurrent] = useState('');
    const [openLogin, setOpenLogin] = useState(false);
    const handleLogin = () =>{
        setOpenLogin(true)
    }
    function getItem(label, key, icon, children) {
        return {
            key,
            icon,
            children,
            label,
        };
    }
    const handleClick = (e) => {
        setCurrent(e.key);
    };
    const menuItems = [
        { menu_name: "SOLUTION", key: "/" },
        { menu_name: "FEATURES", key: '' },
        { menu_name: "ABOUT US", key: '*' },
        { menu_name: "CONTACT", key: '.'}
    ];
    const items = menuItems.map((item) => {
        return (getItem(item.menu_name, item.key))
    });

    return(
        <div>
            {
                openLogin == false ? 
                <Layout className="landingPage">
                    <Header className='bg-white  w-100 d-flex justify-content-between align-items-center header '>
                        <div className="d-flex head1">
                            <div className="homeLogo w-auto">
                                <img src={GarudaLogo} alt="login logo" width="65%"  />
                            </div>
                        
                            {/* <div>
                                <ul className="menu">
                                    <li><a href="#" className="active">SOLUTION</a></li>
                                    <li><a href="#">FEATURES</a></li>
                                    <li><a href="#">ABOUT US</a></li>
                                    <li><a href="#">CONTACT</a></li>
                                </ul>
                            </div> */}
                        </div>
                        <Menu
                                className='bg-white landingPageMenu  col-8  me-auto  '
                                mode="horizontal"
                                defaultSelectedKeys={current}
                                items={items}
                                onClick={(key) => handleClick(key)}
                            />
                        <div className="login-btn-cont d-flex align-items-center">
                            <Button className="login-btn" onClick={handleLogin}>LOGIN</Button>
                        </div>
                        {/* <Menu
                            className='bg-white'
                            mode="horizontal"
                            defaultSelectedKeys={current}
                            items={items}
                            onClick={(key) => handleClick(key)}
                        /> */}
                    </Header>
                    <Content className="site-layout landingPage-main">
                        <div
                            className='bg-white' >
                            {children}
                        </div>
                    </Content>
                    <Footer>
                        <div className={`   mx-auto  footer`}>
                            <h5 className={`  text-center`}>Contact Us now to get your work started</h5>
                            <div className="row mx-auto footerParent d-flex " id="footerParent">
                            <div className="col-md-3   my-auto footer-content">
                                <div className="ps-2 kosoft-img "><img src={KosoftLogo} alt="kosoft logo" width={90} height={40} /></div>
                                <div className="d-flex mt-2">
                                    <div className={`rounded-circle pe-1`}>
                                    <a href="https://twitter.com/KoSoft_official" target="blank"> <img src={twit}  width={30} height={30} alt="twitter"/></a>
                                    </div>
                                    <div className={` rounded-circle pe-1`}>
                                    <a href="https://www.facebook.com/kosoftitsolution" target="blank"> <img src={fb} width={30} height={30} alt="facebook"/></a>
                                    </div>
                                    <div className={` rounded-circle pe-1`}>
                                    <a href="https://instagram.com/kosoft_official" target="blank"> <img src={insta} width={30} height={30} alt="instagram"/></a>
                                    </div>
                                    <div className={` rounded-circle`}>
                                    <a href="https://www.linkedin.com/company/kosoft-solutions" target="blank">  <img src={indeed} width={30} height={30} alt="indeed"/></a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5 footer-content">
                                <h6 className={` develop mt-2`}>Development Center</h6>
                                <p className={`contactcontent`}>No.208, II floor, 100 Feet Road, Mudaliarpet,
                                    <br />
                                    Puducherry 605004, India.<br />
                                    {/* <span className="text-underline link">support@kosoft.co <br />  +91 9943588775 / +91 994358876 </span><br /> */}
                                    <span className="text-underline link text-white">
                                        <a href="mailto:support@kosoft.co" className="mail text-decoration-none ">support@kosoft.co</a>
                                        <br />
                                        <a href="tel:+919943588775" className="mobNum text-white text-decoration-none">+91 9943588775</a> / <a href="tel:+919943588776" className="mobNum text-white text-decoration-none">+91 9943588776</a>
                                    </span>
                                    <span className="d-block">
                                        <a href="http://www.kosoft.co" className="text-underline  link text-white text-decoration-none cmp" target="_blank">www.kosoft.co</a>
                                    </span>
                                    {/* <span className="text-underline link">www.kosoft.co</span> */}
                                </p>
                            </div>
                            <div className="col-md-4 footer-content">
                                <h6 className={` develop mt-2`}>Channel Partner Acira LLC</h6>
                                <p  className={` contactcontent`}>71 Dundee Avenue, Iselin, New Jersey - 08830, USA.
                                    <br />
                                    {/* <span className="text-underline link">support@kosoft.co <br /> +1 (732) 829-9673</span><br /> */}
                                    <span className="text-underline link text-white  ">
                                        <a href="mailto:support@kosoft.co" className="mail text-decoration-none ">support@kosoft.co</a>
                                        <br />
                                        <a href="tel:+17328299673" className="mobNum text-white text-decoration-none">+1 (732) 829-9673</a>
                                    </span>
                                    <span className="d-block">
                                        <a href="http://www.kosoft.co" className="text-underline  link text-white text-decoration-none cmp" target="_blank">www.kosoft.co</a>
                                    </span>

                                    {/* <span className="text-underline link">www.kosoft.co</span> */}
                                </p>
                            </div>
                            </div>
                        </div>
                        <div className="  mx-auto p-3 ps-0 footer footer-content">
                            <p  className={` contactcontent ps-0 text-start  ` }>Powered by Kosoft <span  className={``}> &#169; 2024 - Kosoft IT Solutions Pvt. Ltd. All Rights Reserved</span></p>
                        </div>
                    </Footer>
                </Layout>
                :
                <Login/>
            }
    </div>
    )
}